"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var ResponsiveImageContext = /*#__PURE__*/_react["default"].createContext({});
var _default = ResponsiveImageContext;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJSZXNwb25zaXZlSW1hZ2VDb250ZXh0IiwiUmVhY3QiLCJjcmVhdGVDb250ZXh0Il0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL1Jlc3BvbnNpdmVJbWFnZUNvbnRleHQvUmVzcG9uc2l2ZUltYWdlQ29udGV4dC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5jb25zdCBSZXNwb25zaXZlSW1hZ2VDb250ZXh0ID0gUmVhY3QuY3JlYXRlQ29udGV4dCh7fSk7XG5cbmV4cG9ydCBkZWZhdWx0IFJlc3BvbnNpdmVJbWFnZUNvbnRleHQ7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7O0FBQUE7QUFFQSxJQUFNQSxzQkFBc0IsZ0JBQUdDLGlCQUFLLENBQUNDLGFBQWEsQ0FBQyxDQUFDLENBQUMsQ0FBQztBQUFDLGVBRXhDRixzQkFBc0I7QUFBQSJ9